import React from 'react';
import { useSelector } from 'react-redux'
import { Utils } from '../../services';

export const evaluateAbilityCan = (user, can, owner) => {
    if (!user?.abilities || !can)
        return false;

    const mod = can.split(':')[0];
    const actions = can.split(':')[1];
    if (!(mod in user.abilities))
        return false;

    if (Utils.isMongoAbilityModule(mod)) {
        switch (actions) {
            case 'read':
                return !!user.abilities[mod].readOther;
            case 'edit':
                return !!user.abilities[mod].editOther;
            case 'create':
                return !!user.abilities[mod].create;
            case 'delete':
                return !!user.abilities[mod].deleteOther;
            case 'any':
                return Object.values(user.abilities[mod]).some((value) => value);
            default:
                return user.can(actions, mod);
        }
    }

    switch (actions) {
        case 'read':
            return ((owner && user.abilities[mod].readSelf && user.id === owner) || user.abilities[mod].readOther)
                || (!owner && (user.abilities[mod].readSelf || user.abilities[mod].readOther));
        case 'edit':
            return ((owner && user.abilities[mod].editSelf && user.id === owner) || user.abilities[mod].editOther)
                || (!owner && (user.abilities[mod].editSelf || user.abilities[mod].editOther));
        case 'create':
            return !!user.abilities[mod].create;
        case 'delete':
            return ((owner && user.abilities[mod].deleteSelf && user.id === owner) || user.abilities[mod].deleteOther)
                || (!owner && (user.abilities[mod].deleteSelf || user.abilities[mod].deleteOther));
        case 'any':
            return Object.values(user.abilities[mod]).some((value) => value);
        default:
            return user.can(actions, mod);
    }
};

const Ability = ({ can, canAny, anyModuleIn, owner, children }) => {
    const user = useSelector(state => state.auth.user);

    const checkforAny = (mod) => {
        let returnValue = false;
        for (const key in mod) {
            if (mod[key]) {
                returnValue = true;
                break;
            }
        }
        return returnValue;
    }

    const getAbility = () => {
        if (user?.abilities?.superadmin)
            return true;
        let returnValue = false
        if (user?.abilities) {
            if (anyModuleIn) {
                if (!Array.isArray(anyModuleIn))
                    anyModuleIn = [anyModuleIn]
                anyModuleIn.forEach(a => {
                    if (!returnValue && checkforAny(user.abilities[a]))
                        returnValue = true;
                })
            } else if (canAny) {
                const checks = Array.isArray(canAny) ? canAny : [canAny];
                returnValue = checks.some((permission) => evaluateAbilityCan(user, permission, owner));
            } else if (can) {
                returnValue = evaluateAbilityCan(user, can, owner);
            }
        }
        return returnValue;
    }

    const result = getAbility();

    return (
        result ?
            <>{children}</> :
            <></>
    )
}

export default Ability;
